module.exports = __webpack_public_path__ + "static/img/ifi.2e68e85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/partners/ifi.png
// module id = /FQJ
// module chunks = 1